import { SUPPORTED_LOCALES_LONG } from './localeVariables';

const getLocaleCodeLong = (lang) => {
    return SUPPORTED_LOCALES_LONG.filter(code => code.startsWith(lang));
}

export default getLocaleCodeLong;
